// extracted by mini-css-extract-plugin
module.exports = {"rowContainer":"_2n5uS8Yy1kWtYbZeD2t9Zs","isFirstRow":"_15cdBsIKxCgVSMVh_KCG3W","title":"_3DmZAwOF7T_dwCEKuCVp-X","body":"_7CSXWjtn4a_Fu_YiUO5C1"};